import {useEffect, useState} from 'react'
import {Pressable, StyleSheet, Text, View} from 'react-native'

import {createFirebaseMember} from '#/lib/firebase'
import {type CaptchaWebViewProps} from './CaptchaWebView.shared'

export function CaptchaWebView({state, onSlow}: CaptchaWebViewProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [isCreated, setIsCreated] = useState(false)
  const [error, setError] = useState<string>()

  useEffect(() => {
    const timeout = setTimeout(() => onSlow?.(), 30e3)
    return () => clearTimeout(timeout)
  }, [onSlow])

  const onCreateAccount = async () => {
    if (!state) return
    setIsLoading(true)
    setError(undefined)

    try {
      await createFirebaseMember({
        email: state.email,
        password: state.password,
        handle: state.handle,
      })
      setIsCreated(true)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Inscription impossible')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <View style={styles.container}>
      {isCreated ? (
        <>
          <Text style={styles.title}>Compte Mont2 créé</Text>
          <Text style={styles.description}>
            Ton compte Firebase est créé et ton profil est enregistré dans
            Firestore. Tu peux maintenant revenir à l’accueil.
          </Text>
        </>
      ) : (
        <>
          <Text style={styles.title}>Créer un compte Mont2</Text>
          <Text style={styles.description}>
            Ton inscription utilise Firebase et Firestore. Aucun compte Bluesky
            ni captcha Bluesky n’est nécessaire.
          </Text>
          {error && <Text style={styles.error}>{error}</Text>}
          <Pressable
            accessibilityRole="button"
            accessibilityLabel="Créer un compte Mont2 avec Firebase"
            disabled={isLoading}
            onPress={() => void onCreateAccount()}
            style={({pressed}) => [
              styles.button,
              pressed && styles.buttonPressed,
              isLoading && styles.buttonDisabled,
            ]}>
            <Text style={styles.buttonText}>
              {isLoading ? 'Création en cours…' : 'Créer mon compte Mont2'}
            </Text>
          </Pressable>
        </>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    minHeight: 510,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: 24,
  },
  title: {
    color: '#111827',
    fontSize: 22,
    fontWeight: '600',
    textAlign: 'center',
  },
  description: {
    maxWidth: 520,
    color: '#4B5563',
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
  },
  error: {
    maxWidth: 520,
    color: '#DC2626',
    textAlign: 'center',
  },
  button: {
    borderRadius: 999,
    backgroundColor: '#006AFF',
    paddingHorizontal: 20,
    paddingVertical: 12,
  },
  buttonPressed: {
    opacity: 0.75,
  },
  buttonDisabled: {
    opacity: 0.5,
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
  },
})
